export class productEnum {
    static MATHLETICS = { id: 1, name: 'Mathletics' };
    static SPELLING = { id: 10, name: 'Spelling' };
    static WRITING = { id: 11, name: 'Writing' };
}

export const PRODUCTS = {
    [productEnum.MATHLETICS.id]: [productEnum.MATHLETICS.name],
    [productEnum.SPELLING.id]: [productEnum.SPELLING.name],
    [productEnum.WRITING.id]: [productEnum.WRITING.name]
};



// WEBPACK FOOTER //
// ./app/helpers/product-enum.js